import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import Gift from '../Gift'
import { SimpleList } from '@/checkout-instore-legacy/components/Commons/Elements/SimpleList'
import * as GiftsUtils from '@/checkout-instore-legacy/utils/GiftsUtils'
import { logClickEvent } from '@/checkout-instore-legacy/utils/EventHelper'

export default class GiftGroup extends React.Component {
  toggleGiftSelection = (gift) => {
    const { giftGroup } = this.props
    const selectedGifts = GiftsUtils.changeSelectedGifts(giftGroup, gift)
    logClickEvent('gift-item', 'Sale')
    this.props.changeSelectedGifts(giftGroup.id, selectedGifts)
  }

  render() {
    const { giftGroup } = this.props
    const availableGifts = giftGroup.availableGifts

    const giftList = availableGifts.map((gift, index) => {
      return (
        <Gift
          onClick={() => {
            this.toggleGiftSelection(gift)
          }}
          key={index}
          gift={gift}
        />
      )
    })

    const selectedGifts = availableGifts.filter((gift) => {
      return gift.isSelected
    })
    const remainingGifts = giftGroup.availableQuantity - selectedGifts.length

    return (
      <div data-testid="gift-group" className="mt3 mb5 pv5 ph5">
        <div className="flex-none flex items-center">
          <div className="flex-auto fw3 gray pv4 pv5-ns ph5 f5 f4-ns lh-copy">
            <FormattedMessage
              id="chooseGiftGroup"
              values={{
                selectedGifts: selectedGifts.length,
                availableQuantity: giftGroup.availableQuantity,
                remainingGifts,
              }}
            />
          </div>
        </div>

        <SimpleList>{giftList}</SimpleList>
      </div>
    )
  }
}

GiftGroup.propTypes = {
  giftGroup: PropTypes.any,
  changeSelectedGifts: PropTypes.func.isRequired,
}
